import { Tool, ToolType } from './tool';
import { LevelDesignerComponent } from '../level-designer/level-designer.component';
import { LevelDesignerElementBase } from '../elements/element-base';
import { VisualTool } from './tool-base-types';
import { PassiveTool } from './tool-base-types';
import { ActionTool } from './tool-base-types';
import { PolygonElement } from '../elements/polygon-element';
import { ToolGroup } from './tool-group';
import { ParkingLevelElement } from '../elements/parking/parkinglevel';

export class ToggleMapmodeTool extends VisualTool {
    private readonly FONT_SIZE = 14;
    private readonly PADDING = 5;

    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, ToolType.Toggle, 'assets/icons/map.svg');
       
    }
    override getTooltip(): string {
        return 'Toggle Map Mode';
    }

    getName(): string {
        return 'Toggle Map Mode';
    }

    override onActivated(): void {
        this.levelDesigner.MapMode = true;
        
        // Find the parking level element
        const parkingLevel = this.levelDesigner.elements.find(e => e instanceof ParkingLevelElement) as ParkingLevelElement;
        
        // if (parkingLevel) {
        //     // Store the current view state to restore when deactivating
        //     this._savedScale = this.levelDesigner.getScale();
        //     this._savedOffsetX = this.levelDesigner.getOffsetX();
        //     this._savedOffsetY = this.levelDesigner.getOffsetY();
            
        //     // Reset the view to a reasonable zoom level for the map
        //     this.levelDesigner.setScale(1.0);
            
        //     // Center the view on the canvas
        //     if (this.canvas) {
        //         this.levelDesigner.setOffsetX(this.canvas.width / 2);
        //         this.levelDesigner.setOffsetY(this.canvas.height / 2);
        //     }
        // }
        
        this.levelDesigner.redraw();
    }

    private _savedScale: number = 1.0;
    private _savedOffsetX: number = 0;
    private _savedOffsetY: number = 0;

    public override onDeactivated(): void {
        this.levelDesigner.MapMode = false;
        
        // Clear the tile cache when exiting map mode
        // if ((this.levelDesigner as any).constructor.tileCache) {
        //     (this.levelDesigner as any).constructor.tileCache.clear();
        // }
        
        // // Restore the previous view state
        // this.levelDesigner.setScale(this._savedScale);
        // this.levelDesigner.setOffsetX(this._savedOffsetX);
        // this.levelDesigner.setOffsetY(this._savedOffsetY);
        
        this.levelDesigner.redraw();
    }

    onClick(x: number, y: number): void {
        // No additional click handling needed
    }

    onKeyPress(key: string): void {
        // No additional key handling needed
    }

    public override getButtonWidth(): number {
        return 40;
    }


    public override render(ctx: CanvasRenderingContext2D): void {
        
    }

    
}
